import { useCustomRouter } from '@vette/frontend-utils';
import { default as NextLink, LinkProps } from 'next/link';
import React from 'react';

type Props = React.PropsWithChildren<{ href: string } & LinkProps>;

export const Link: React.FC<Props> = ({ href, children, ...props }) => {
  const { getPath } = useCustomRouter();

  return (
    <NextLink {...props} href={getPath(href)}>
      {children}
    </NextLink>
  );
};
